import { applyBrandTokens } from './brand';

/**
 * Mantém os tokens de marca (--tc-action e derivados) em sincronia com o tema
 * ativo do Vuetify.
 *
 * POR QUE PRECISA DE WATCHER, e não de uma chamada no bootstrap:
 * os tokens derivam do `primary` VIGENTE, e o primary muda em dois momentos
 * que não passam pelo createVuetify():
 *
 *   1. o app aplica o `isDark` persistido em localStorage DEPOIS do boot —
 *      quem usa tema escuro ficaria com a cor de ação do tema claro (no
 *      symcapital isso é ação preta sobre fundo escuro);
 *   2. a troca de tenant (ThemePickerModal, seletor do /ui) reescreve a paleta.
 *
 * Depender de cada ponto lembrar de chamar syncBrandTokens é frágil — o
 * watcher fecha o buraco de uma vez.
 *
 * @param {import('vue').default} app  instância raiz do Vue (tem $vuetify)
 */
export function installBrandSync(app) {
  const tema = app?.$vuetify?.theme;

  if (!tema) return;

  app.$watch(
    () => {
      const t = app.$vuetify.theme;

      // currentTheme já devolve a variante ativa; o `dark` entra na chave para
      // disparar o watcher mesmo quando as duas variantes têm o mesmo primary.
      return `${t.dark ? 'dark' : 'light'}|${t.currentTheme && t.currentTheme.primary}`;
    },
    () => {
      const t = app.$vuetify.theme;

      // O 2º argumento é o primary CANÔNICO (tema claro): o shell de navegação
      // é escuro nos dois temas e não pode seguir o primary do tema escuro, que
      // é uma versão clareada — no symcapital ele é #FFFFFF.
      applyBrandTokens(t.currentTheme.primary, t.themes.light && t.themes.light.primary, {
        darkPrimary: t.themes.dark && t.themes.dark.primary,
        accent: t.currentTheme.accent
      });
    },
    { immediate: true }
  );
}

export default installBrandSync;
